import { render, staticRenderFns } from "./ManualBooking.vue?vue&type=template&id=50edf157&"
import script from "./ManualBooking.vue?vue&type=script&lang=js&"
export * from "./ManualBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports